import React from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    Table,
    Badge
} from "reactstrap";
import { formatPeriodRange } from "../../utils/date";

/**
 * Detalle del top de redes: la tabla completa y, al elegir un distribuidor,
 * su desglose por nivel.
 *
 * El desglose ya viene en la respuesta del top, así que abrir una fila no
 * dispara ninguna consulta nueva.
 */
const TopNetworksModal = ({
    isOpen,
    toggle,
    networks = [],
    settlement,
    formatPoints,
    formatMoney
}) => {

    const [selected, setSelected] = React.useState(null);

    // Al cerrar se limpia la selección para que la próxima apertura empiece
    // en la tabla y no en el detalle del anterior.
    React.useEffect(() => {
        if (!isOpen) setSelected(null);
    }, [isOpen]);

    const periodLabel = formatPeriodRange(settlement?.period);

    return (

        <Modal isOpen={isOpen} toggle={toggle} size="lg" centered scrollable>

            <ModalHeader toggle={toggle}>

                <div>

                    <div style={{ fontSize: 17, fontWeight: 700, color: "#101828" }}>
                        {selected ? selected.user?.name || "Distribuidor" : "Redes más activas"}
                    </div>

                    {
                        periodLabel && (
                            <small style={{ color: "#98A2B3", fontWeight: 400 }}>
                                {settlement?.source === "DASHBOARD_CACHE"
                                    ? `Mes en curso ${periodLabel} · cifras preliminares`
                                    : `Corte ${periodLabel}`}
                            </small>
                        )
                    }

                </div>

            </ModalHeader>

            <ModalBody>

                {

                    !selected && (

                        <Table responsive hover className="mb-0">

                            <thead>
                                <tr style={{ fontSize: 12, color: "#98A2B3" }}>
                                    <th>#</th>
                                    <th>Distribuidor</th>
                                    <th>Código</th>
                                    <th className="text-end">Puntos</th>
                                    <th className="text-center">Usuarios</th>
                                    <th className="text-center">Órdenes</th>
                                    <th className="text-end">Regalía liquidada</th>
                                </tr>
                            </thead>

                            <tbody>

                                {
                                    networks.map((network, index) => (

                                        <tr
                                            key={network.user_id}
                                            style={{ cursor: "pointer", fontSize: 13 }}
                                            onClick={() => setSelected(network)}
                                        >
                                            <td style={{ color: "#667085", fontWeight: 600 }}>
                                                {index + 1}
                                            </td>
                                            <td style={{ color: "#344054", fontWeight: 500 }}>
                                                {network.user?.name || "—"}
                                            </td>
                                            <td style={{ color: "#98A2B3" }}>
                                                {network.user?.multyhealth_code || "—"}
                                            </td>
                                            <td className="text-end" style={{ fontWeight: 600 }}>
                                                {formatPoints(network.total_points)}
                                            </td>
                                            <td className="text-center">
                                                {network.network_users_count}
                                            </td>
                                            <td className="text-center">
                                                {network.orders_count}
                                            </td>
                                            <td className="text-end" style={{ color: "#667085" }}>
                                                {formatMoney(network.value_by_currency)}
                                            </td>
                                        </tr>

                                    ))
                                }

                            </tbody>

                        </Table>

                    )

                }

                {

                    selected && (

                        <>

                            <button
                                type="button"
                                className="btn btn-link px-0 mb-3"
                                style={{ textDecoration: "none", color: "#4F46E5", fontWeight: 600, fontSize: 13 }}
                                onClick={() => setSelected(null)}
                            >
                                ← Volver al listado
                            </button>

                            <div className="d-flex flex-wrap gap-4 mb-4">

                                <div>
                                    <div style={{ fontSize: 12, color: "#98A2B3" }}>Puntos</div>
                                    <div style={{ fontSize: 20, fontWeight: 700, color: "#101828" }}>
                                        {formatPoints(selected.total_points)}
                                    </div>
                                </div>

                                <div>
                                    <div style={{ fontSize: 12, color: "#98A2B3" }}>Usuarios en la red</div>
                                    <div style={{ fontSize: 20, fontWeight: 700, color: "#101828" }}>
                                        {selected.network_users_count}
                                    </div>
                                </div>

                                <div>
                                    <div style={{ fontSize: 12, color: "#98A2B3" }}>Órdenes</div>
                                    <div style={{ fontSize: 20, fontWeight: 700, color: "#101828" }}>
                                        {selected.orders_count}
                                    </div>
                                </div>

                                <div>
                                    <div style={{ fontSize: 12, color: "#98A2B3" }}>Regalía liquidada</div>
                                    <div style={{ fontSize: 20, fontWeight: 700, color: "#101828" }}>
                                        {formatMoney(selected.value_by_currency)}
                                    </div>
                                </div>

                                <div>
                                    <div style={{ fontSize: 12, color: "#98A2B3" }}>Estado de pago</div>
                                    <Badge color="light" className="text-dark border">
                                        {selected.paid_status || "PENDING"}
                                    </Badge>
                                </div>

                            </div>

                            <h6 className="fw-bold mb-2" style={{ color: "#101828" }}>
                                Desglose por nivel
                            </h6>

                            <Table responsive className="mb-0">

                                <thead>
                                    <tr style={{ fontSize: 12, color: "#98A2B3" }}>
                                        <th>Nivel</th>
                                        <th className="text-end">%</th>
                                        <th className="text-end">Puntos</th>
                                        <th className="text-center">Usuarios</th>
                                        <th className="text-center">Órdenes</th>
                                        <th className="text-end">Valor</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {
                                        (selected.levels || []).map((level) => (

                                            <tr key={level.level} style={{ fontSize: 13 }}>
                                                <td style={{ fontWeight: 600, color: "#344054" }}>
                                                    Nivel {level.level}
                                                </td>
                                                <td className="text-end" style={{ color: "#667085" }}>
                                                    {Math.round((level.percentage || 0) * 100)}%
                                                </td>
                                                <td className="text-end">
                                                    {formatPoints(level.points)}
                                                </td>
                                                <td className="text-center">
                                                    {level.users_count}
                                                </td>
                                                <td className="text-center">
                                                    {level.orders_count}
                                                </td>
                                                <td className="text-end" style={{ color: "#667085" }}>
                                                    {new Intl.NumberFormat("es-CO").format(Math.round(level.value || 0))}
                                                </td>
                                            </tr>

                                        ))
                                    }

                                    {
                                        (selected.levels || []).length === 0 && (
                                            <tr>
                                                <td colSpan={6} className="text-center" style={{ color: "#98A2B3", fontSize: 13 }}>
                                                    Sin desglose por nivel en este corte.
                                                </td>
                                            </tr>
                                        )
                                    }

                                </tbody>

                            </Table>

                        </>

                    )

                }

            </ModalBody>

        </Modal>

    );

};

export default TopNetworksModal;
